import React, { useState, useEffect, useRef } from 'react';
import { CopyOutlined, SendOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import style from '../../AlmatyBusinessChats/AlmatyBusinessChatPreset/AlmatyBusinessChatPreset.module.css';
import ai_prep_message from '../../../assets/ai_prep_message.svg';
import ai_prep_bigger from '../../../assets/ai_prep_bigger.svg';
// FIXME RCP URL FOR AI ASSISTANT
// const apiUrl = 'https://asst.metatable.ai/create_message'
// const apiUrl = 'https://atamekenvc.metatable.ai/create_message';
const authToken =
  '2b993bb5aa86d16f300224326e7f864804ddb99b2dd91f017367bc5c9aae5621';

function formatMessageText(text) {
  return text.replace(/\[([^\]]+)\]\((https?:\/\/[^\s\)\]\}]+)\)/g, (match, label, url) => {
    return `<a href="${url}" class="messageUrl" style="color: #fff; font-weight: bold" target="_blank">${url}</a>`;
  });
}

function ABChatV2(props) {
  const { apiUrl, promptMessage, preparedMessages } = props;

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [threadId, setThreadId] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [containerHeight, setContainerHeight] = useState('100vh');
  const [addMargin, setAddMargin] = useState(false);
  const msgContainer = useRef();
  const [popoverOpen, setPopoverOpen] = useState(false);

  useEffect(() => {
    // Добавляем стартовое сообщение при загрузке виджета
    const initialMessage = {
      text: promptMessage,
      fromUser: false,
    };
    setMessages([initialMessage]);
  }, []);
  function processText(input) {
    // Разбиваем текст на строки
    const lines = input.split(/(?<=\\.)\\d+\\.\\s/); // Разделяем по номеру с точкой и пробелом
    const result = [];

    lines.forEach((line) => {
      // Убираем `**` и заменяем содержимое внутри `【】` на пустую строку
      const cleanedLine = line
        .replace(/\\*\\*/g, '')
        .replace(/【[^】]*】/g, '')
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
        .replace(/(\s\d+\.)/g, '<br/>$1')
        .replace(/(\s-\s)/g, '<br/>$1');

      if (cleanedLine.trim()) {
        result.push(cleanedLine.trim());
      }
    });

    // Возвращаем текст с новой строки для каждого пункта
    return result.join('\\n');
  }

  const sendMessage = async (msg) => {
    const text = typeof msg === 'string' ? msg : input;

    if (!text.trim()) return;

    // Отображаем исходящее сообщение
    const newMessages = [...messages, { text, fromUser: true }];
    setMessages(newMessages);
    setInput('');
    setIsTyping(true);
    setTimeout(() => {
      if (msgContainer.current) {
        msgContainer.current.scrollTop = msgContainer.current.scrollHeight;
      }
    }, 0);
    // Отправляем сообщение в API
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          message: text,
          thread_id: threadId,
        }),
      });
      const data = await response.json();

      // debugger

      // Сохраняем thread_id при первом ответе
      if (!threadId) {
        setThreadId(data.thread_id);
      }

      // Анимация печати входящего сообщения
      // animateIncomingMessage(data.message, newMessages);




      animateIncomingMessage(formatMessageText(data.result), newMessages);
    } catch (error) {
      console.error('Ошибка при запросе API:', error);
    } finally {
      setIsTyping(false);
    }
  };

  // Функция для анимации печати текста побуквенно
  const animateIncomingMessage = (text, newMessages) => {
    let index = 0;
    const intervalId = setInterval(() => {
      setMessages([
        ...newMessages,
        { text: processText(text.slice(0, index + 1)), fromUser: false },
      ]);
      index++;
      if (msgContainer.current) {
        msgContainer.current.scrollTop = msgContainer.current.scrollHeight;
      }
      if (index === text.length) {
        clearInterval(intervalId);
      }
    }, 5); // Скорость печати в миллисекундах
  };

  const changeContainerHeight = () => {
    setContainerHeight(window.visualViewport.height - 70);
  };

  useEffect(() => {
    window.visualViewport.addEventListener('resize', changeContainerHeight);
  }, []);

  const copyResponse = (message) => {
    navigator.clipboard.writeText(message);
  };

  const popoverContent = (
    <div>
      {preparedMessages.map((item) => {
        return (
          <div
            className={style.preparedMessage_popover_option}
            onClick={() => {
              sendMessage(item);
              setPopoverOpen(false);
            }}
          >
            {item}
          </div>
        );
      })}
    </div>
  );


  return (
    <>
      <div
        style={{
          ...styles.chatContainer,
          // height: containerHeight,
          // marginTop: addMargin ? '30%' : 'unset',
        }}
      >
        <div style={styles.messagesContainer} ref={msgContainer}>
          <div style={styles.chatTitleBox}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path d="M9.813 15.904L9 18.75L8.187 15.904C7.97687 15.1689 7.5829 14.4994 7.04226 13.9587C6.50162 13.4181 5.83214 13.0241 5.097 12.814L2.25 12L5.096 11.187C5.83114 10.9769 6.50062 10.5829 7.04126 10.0423C7.5819 9.50162 7.97587 8.83214 8.186 8.097L9 5.25L9.813 8.096C10.0231 8.83114 10.4171 9.50062 10.9577 10.0413C11.4984 10.5819 12.1679 10.9759 12.903 11.186L15.75 12L12.904 12.813C12.1689 13.0231 11.4994 13.4171 10.9587 13.9577C10.4181 14.4984 10.0241 15.1679 9.814 15.903L9.813 15.904ZM18.259 8.715L18 9.75L17.741 8.715C17.5927 8.12159 17.286 7.57962 16.8536 7.14703C16.4212 6.71444 15.8794 6.40749 15.286 6.259L14.25 6L15.286 5.741C15.8794 5.59251 16.4212 5.28556 16.8536 4.85297C17.286 4.42038 17.5927 3.87841 17.741 3.285L18 2.25L18.259 3.285C18.4073 3.87854 18.7142 4.42059 19.1468 4.85319C19.5794 5.28579 20.1215 5.59267 20.715 5.741L21.75 6L20.715 6.259C20.1215 6.40733 19.5794 6.71421 19.1468 7.14681C18.7142 7.57941 18.4073 8.12147 18.259 8.715ZM16.894 20.567L16.5 21.75L16.106 20.567C15.9955 20.2356 15.8094 19.9345 15.5625 19.6875C15.3155 19.4406 15.0144 19.2545 14.683 19.144L13.5 18.75L14.683 18.356C15.0144 18.2455 15.3155 18.0594 15.5625 17.8125C15.8094 17.5655 15.9955 17.2644 16.106 16.933L16.5 15.75L16.894 16.933C17.0045 17.2644 17.1906 17.5655 17.4375 17.8125C17.6845 18.0594 17.9856 18.2455 18.317 18.356L19.5 18.75L18.317 19.144C17.9856 19.2545 17.6845 19.4406 17.4375 19.6875C17.1906 19.9345 17.0045 20.2356 16.894 20.567Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h3 style={styles.chatTitle}>
              Виртуальный ассистент
            </h3>
          </div>
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                justifyContent: index % 2 === 0 ? 'flex-start' : 'flex-end',
              }}
            >
              <div
                style={{
                  ...styles.message,
                  ...(msg.fromUser ? styles.userMessage : styles.apiMessage),
                }}
              >
                <p
                  style={styles.messageText}
                  dangerouslySetInnerHTML={{ __html: msg.text }} // Используем dangerouslySetInnerHTML для отображения HTML
                />
                {!msg.fromUser && index !== 0 && (
                  <CopyOutlined
                    onClick={() => copyResponse(msg.text)}
                    style={styles.copyButton}
                  />
                )}
              </div>
            </div>
          ))}
          {isTyping && (
            <div style={styles.typingIndicator}>
              <p style={{ margin: 'unset' }}>...</p>
            </div>
          )}
        </div>
      </div>
      <div style={styles.inputContainer}>
        {preparedMessages.length > 0 ? (
          messages.length === 1 ? (
            <div style={styles.preparedMessages_wrapper}>
              <div
                style={{
                  display: 'flex',
                  columnGap: 12,
                  width:
                    preparedMessages.length * 185 +
                    (preparedMessages.length - 2) * 20,
                }}
              >
                {preparedMessages.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={styles.preparedMessage}
                      onClick={() => sendMessage(item)}
                    >
                      <div style={styles.preparedMessage_badge}>
                        <img src={ai_prep_message} />
                      </div>
                      {item}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <Popover
              open={popoverOpen}
              content={popoverContent}
              trigger="click"
              overlayInnerStyle={styles.preparedMessage_popover}
            >
              <div
                style={styles.preparedMessage_popover_button}
                onClick={() => setPopoverOpen(!popoverOpen)}
              >
                <img src={ai_prep_bigger} />
              </div>
            </Popover>
          )
        ) : (
          ''
        )}
        <input
          onFocus={() => setAddMargin(true)}
          onBlur={() => setAddMargin(false)}
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ваш вопрос..."
          style={styles.input}
          onKeyDown={(e) => e.key === 'Enter' && sendMessage}
        />

        {/*<SendOutlined style={styles.sendButton} onClick={sendMessage} />*/}

         <button onClick={sendMessage} style={styles.sendButton}>
         Отправить
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={styles.sendButtonIcon}>
             <g clip-path="url(#clip0_1330_2465)">
               <path d="M8.56113 13.8167L1.61523 10.1396C6.66209 7.36699 12.1453 5.47638 17.8285 4.5493C16.9016 10.2323 15.0112 15.7153 12.2388 20.762L8.56113 13.8167ZM8.56113 13.8167L13.0497 9.32812" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
             </g>
             <defs>
               <clipPath id="clip0_1330_2465">
                 <rect width="24" height="24" fill="white"/>
               </clipPath>
             </defs>
           </svg>
         </button>
      </div>
    </>
  );
}

const styles = {
  chatContainer: {
    width: '100%',
    overflow: 'hidden',
    fontFamily: 'Inter',
    height: '100%',
    transition: '0.3s all',
    background: 'linear-gradient(131.19deg, #70a17e 0%, #3d7769 50% 100%)',
    padding: '35px',
    borderTopRightRadius: '45px',
    borderTopLeftRadius: '45px',
    borderRadius: '0',
  },
  chatTitleBox: {
    display: 'flex',
    alignItems: 'center',
  },
  chatTitle: {
    marginLeft: '15px',
    fontSize: '20px',
    color: '#fff'
  },
  messagesContainer: {
    maxHeight: '100%',
    overflowY: 'auto',
  },
  message: {
    marginBottom: '10px',
    padding: '8px 12px',
    maxWidth: '80%',
    display: 'inline-block',
    position: 'relative',
    color: 'red',
  },
  userMessage: {
    // backgroundColor: 'black',
    alignSelf: 'flex-end',
    textAlign: 'left',
    marginLeft: 'auto',
    color: 'white',
    borderRadius: '18px 0px 18px 18px',
    background: 'rgba(255, 255, 255, 0.3)',
  },
  apiMessage: {
    backgroundColor: '#FFF',
    border: '1px solid #e6e6e6',
    color: '#fff',
    textAlign: 'left',
    borderRadius: '0px 18px 18px 18px',
    // background: 'linear-gradient(180deg, #52876e 0%, #538872 45%)',
    background: 'rgba(255,255,255, 0.1)',
  },
  typingIndicator: {
    marginBottom: '10px',
    padding: '8px 12px',
    borderRadius: '18px 18px 18px 0px',
    display: 'inline-block',
    backgroundColor: '#e6e6e6',
    color: '#666',
    fontStyle: 'Inter',
    fontWeight: 900,
    fontSize: '16px',
    lineHeight: '24px',
  },
  messageText: {
    margin: 0,
    fontSize: '16px',
    lineHeight: '24px',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '20px 35px',
    background: '#79a091',
    borderBottomLeftRadius: '45px',
    borderBottomRightRadius: '45px',
    borderRadius: '0',
  },
  input: {
    // flex: 1,
    padding: '10px',
    borderRadius: '12px',
    border: '1px solid #ddd',
    outline: 'none',
    fontFamily: 'Inter',
    fontSize: '16px',
    lineHeight: '24px',
    background: '#86b0a6',
    width: 'calc(100% - 165px)',
    color: '#fff'

  },
  sendButton: {
    padding: '12px 12px',
    border: 'none',
    borderRadius: '18px',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
    position: 'absolute',
    zIndex: 1,
    right: 0,
    fontSize: 16,
    backgroundColor: '#86b0a6',
    width: '145px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: '35px',

  },
  sendButtonIcon: {
    fontSize: 20,
    color: "#fff",
    order: 1
  },
  sendButtonHover: {
    backgroundColor: '#0056b3',
  },
  copyButton: {
    position: 'absolute',
    right: -25,
    color: 'grey',
    fontSize: 20,
    bottom: 0,
  },
  preparedMessages_wrapper: {
    position: 'absolute',
    bottom: '105px',
    width: '100%',
    overflowX: 'scroll',
    left: '35px'
  },
  preparedMessage: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid #fff',
    borderRadius: '12px',
    fontSize: '14px',
    lineHeight: '21px',
    fontFamily: 'Inter',
    color: '#fff',
    padding: '15px 10px 10px 10px',
    position: 'relative',
    width: 185,
    marginTop: 15,
    cursor: 'pointer',
  },
  preparedMessage_badge: {
    position: 'absolute',
    left: '50%',
    top: '-15px',
    transform: 'translateX(-50%)',
    background: '#3d7769',
    borderRadius: '100%',
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #fff',
  },
  preparedMessage_popover_button: {
    position: 'absolute',
    top: '-60px',
    right: '0',
    background: 'black',
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  preparedMessage_popover: {
    background: '#fff',
    padding: 15,
  },
  messageUrl: {
    color: '#fff'
  }
};

export default ABChatV2;
